/* eslint-disable no-plusplus */
import PropTypes from 'prop-types';
import React, { useEffect, useState, useRef } from 'react';
import cuid from 'cuid';
import { pageContext } from 'ctm-util-functions';
import styled from 'styled-components';
import { SimpleFlexbox } from '../../../../../flexbox/flexbox';
import styles from './features_header.css';

const Container = styled.div`
    width: ${(props) => props.width};
`;

/**
 * The features header, renders a layout with passed in product data
 * @param {Object} props - properties to render the component
 * @param {Array} props.xs - componentLists for xs breakpoint and above
 * @param {Object} props.stateProps - The stateful product object passed in
 * @returns {Node} the features header affixed component with optional label and quote headers
 * @constructor
 */
const LayoutFeatureHeaderCellAffixed = ({ xs, stateProps, numOfQuotes }) => {
    let i = 0;
    const { constructComponents } = pageContext.getProps().director;
    const { product } = stateProps;

    const currentBreakpoint = pageContext.getProps().pageState.breakpoint;

    const getBreakpointWidth = (numOfProductsToRender, breakpoint) => {
        const baseWidths = {
            xs: numOfProductsToRender === 1 ? 50 : 25,
            sm: 25,
            md: 25,
            lg: 25,
            xl: 16.66,
            xxl: 16.66
        };

        const twoColumnAdjustment = {
            xs: 16.66,
            sm: 16.66,
            md: 16.66,
            lg: 16.66,
            xl: 12.46,
            xxl: 12.46
        };

        const width = numOfProductsToRender === 2 ? twoColumnAdjustment[breakpoint] : baseWidths[breakpoint];

        return `${width}%`;
    };

    return product ? (
        <SimpleFlexbox className={styles.affixed} flex={1} border="right">
            <SimpleFlexbox padding="all_small">
                <SimpleFlexbox display="flex">
                    <SimpleFlexbox flex={3} display="flex" itemsCenter="xs" contentCenter="xs" variant="text_align_center">
                        {constructComponents(xs[i++], { stateProps })}
                    </SimpleFlexbox>
                    <SimpleFlexbox display="block" xs={0}>
                        {constructComponents(xs[i++], { stateProps })}
                    </SimpleFlexbox>
                </SimpleFlexbox>
                <SimpleFlexbox xs={0}>{constructComponents(xs[i++], { stateProps })}</SimpleFlexbox>
                <SimpleFlexbox xs={12} sm={0} md={0} lg={0} xl={0} xxl={0} gapless="xs">
                    {constructComponents(xs[i++], { stateProps })}
                </SimpleFlexbox>
                <SimpleFlexbox>{constructComponents(xs[i], { stateProps })}</SimpleFlexbox>
            </SimpleFlexbox>
        </SimpleFlexbox>
    ) : (
        <>
            {/* This will create empty psuedo elements that will help align the Sticky Container with the rest of the features table */}
            {Array.from({ length: numOfQuotes }).map((item, index) => {
                const width = getBreakpointWidth(numOfQuotes, currentBreakpoint);
                return <Container key={cuid()} width={width} />;
            })}
        </>
    );
};

LayoutFeatureHeaderCellAffixed.propTypes = {
    xs: PropTypes.arrayOf(PropTypes.array),
    stateProps: PropTypes.object,
    numOfQuotes: PropTypes.number
};

export { LayoutFeatureHeaderCellAffixed };
